module.exports = __webpack_public_path__ + "media/test/step_1-e15f5b4c.png";